import { render } from "./Appointment.vue?vue&type=template&id=319d7a71"
import script from "./Appointment.vue?vue&type=script&lang=ts"
export * from "./Appointment.vue?vue&type=script&lang=ts"

import "./Appointment.vue?vue&type=style&index=0&id=319d7a71&lang=css"
script.render = render

export default script